import Vue from 'vue';

const EventBus = new Vue();

class EventBusPlugin {
  public static install(vue: typeof Vue, options?: any) {
    if (!vue.prototype.$bus) {
      Object.defineProperties(vue.prototype, {
        $bus: {
          get() {
            return EventBus;
          },
        },
      });
    }
  }
}

export { EventBus as default, EventBusPlugin };
